export default "<div data-component=\"app-error-message\">\n  <p class=\"error\" *ngIf=\"errorMessage !== null\">{{ errorMessage }}</p>\n</div>\n"